import ru from './lang/ru'
import en from './lang/en'

export default {ru: ru, en: en}



// WEBPACK FOOTER //
// ./src/i18n/Language.js